/**
 * AccreditationBand — Feb 2026 with real STEM.org artwork.
 *
 * Replaces the prior icon placeholders with the actual brand badges
 * supplied by the owner. The .tiff Best-in-STEM seal is routed through
 * Cloudinary's `f_auto,q_auto` transform so it ships as web-friendly
 * webp/png to the browser.
 */
import SectionHeading from './SectionHeading';

const STEM_ACCREDITED_BADGE =
  'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782230221/STM_BrandAssets_POS_BADGE_ACC-EXP_VER_kq7oiz.png';
const BEST_IN_STEM_SEAL =
  'https://res.cloudinary.com/dfa8raimq/image/upload/f_auto,q_auto/v1782230221/Best_In_STEM_Seal_b2mwnw.tiff';

const MARKS = [
  {
    src: BEST_IN_STEM_SEAL,
    alt: 'Best In STEM Seal — STEM.org',
    title: 'Best In STEM',
    body: "STEM.org's award for programs that demonstrate exceptional, hands-on STEM learning.",
    pin: 'Top 5% nationally',
  },
  {
    src: STEM_ACCREDITED_BADGE,
    alt: 'STEM.org Accredited Educational Experience badge',
    title: 'Accredited Educational Experience',
    body: 'Independent review of curriculum quality and the camper experience, end to end.',
    pin: 'Verified by STEM.org',
  },
];

export default function AccreditationBand() {
  return (
    <section
      id="accreditation"
      className="bg-rsc-slate-soft py-16 sm:py-20 font-poppins scroll-mt-32"
      data-testid="accreditation-band"
    >
      <div className="container-app">
        <SectionHeading
          eyebrow="Recognized nationally"
          title="Dual-recognized by"
          accent="STEM.org"
          body="Two independent trustmarks, earned by the top 5% of STEM programs nationally. It means our curriculum and experience were reviewed by people outside our own walls."
        />

        <div className="mt-10 grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {MARKS.map((m) => (
            <div
              key={m.title}
              className="rounded-2xl bg-white border border-rsc-card-border shadow-sm p-6 flex items-start gap-5"
            >
              <img
                src={m.src}
                alt={m.alt}
                loading="lazy"
                className="w-20 h-20 sm:w-24 sm:h-24 object-contain flex-shrink-0"
              />
              <div className="min-w-0">
                <h4 className="text-base sm:text-lg font-extrabold text-rsc-brand-blue leading-tight">
                  {m.title}
                </h4>
                <p className="mt-1.5 text-sm text-rsc-charcoal leading-relaxed">{m.body}</p>
                <span className="inline-block mt-3 text-[11px] uppercase tracking-wider font-bold text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-full">
                  {m.pin}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
